module.exports = __webpack_public_path__ + "images/twitter-icon.svg";